export default "__VITE_ASSET__BnWnKZ6m__"